import { useState, useEffect, useContext } from 'react';
import {UserContext} from '../contexts';

export const usePage = () => {
    const [user] = useContext(UserContext);
    const [isLoading, setIsLoading] = useState(false);
    const [errorLoading, setErrorLoading] = useState(null);
    const [data, setData] = useState(null);
    const [content, setContent] = useState({});

    useEffect(() => {
        let title = '';
        let description = '';
        let keyWords = '';
        let image = '';
        let metaTips = '';
        let content = {};
        if (data) {
          title = data.title ? data.title : title;
          description = data.description ? data.description : description;
          keyWords = data.keyWords ? data.keyWords : keyWords;
          image = data.image ? data.image : image;
          metaTips = data.metaTips ? data.metaTips : metaTips;
          try {
            content = JSON.parse(data.content);
            if(!content) {
                content = {};
            }
          } catch (e) {}
        }
        let seo = content.seo ? content.seo : {};
        seo = {...seo, title: title, description: description, keyWords: keyWords, image: image, metaTips: metaTips};
        content.seo = seo;
        
        setContent(content);
    }, [data]);

    const getPage = (pageKey, lang, workspace, comboId) => {
        if(data && data.pageKey === pageKey && data.lang === lang && data.workspace === workspace) {
            return;
        }
        setIsLoading(true);
        window.cet.microservices.nairobiapi.pages
          .getPage({ pageKey: pageKey, language: lang, workspace: workspace })
          .then((_data) => {
            // Store comboId for tracking which combo was used
            setData({ ..._data, comboId: comboId, workspace: workspace });
            setErrorLoading(null);
            setIsLoading(false);
          })
          .catch((error) => {
            setData(null);
            setErrorLoading(error);
            setIsLoading(false);
          });
    };

    const setPage = (section, content) => {
        let pageContent = {...content};
        if(!pageContent[section]) {
            pageContent[section] = {};
        }
        pageContent[section].last_update = {
            editor: user && user.displayName ? user.displayName : '',
            time: new Date()
        };

        var fetch = window.cet.microservices.nairobiapi.pages.setPage({
            lang: data.lang,
            workspace: data.workspace,
            pageKey: data.pageKey,
            title: pageContent.seo.title,
            description: pageContent.seo.description,
            keyWords: pageContent.seo.keyWords,
            image: pageContent.seo.image,
            content: JSON.stringify(pageContent)
        });
        fetch.then(() => {
            setContent(pageContent);
        });
        return fetch;
    };

    const clearErrorMessageLoading = () => {
        setErrorLoading(false);
    };

    return {
        isLoadingPage: isLoading,
        errorLoadingPage: errorLoading,
        pageContent: content,
        pageData: data,
        getPage: getPage,
        setPage: setPage,
        clearErrorMessageLoading: clearErrorMessageLoading
    };
};